var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 50,
    viewBox: "0 0 43 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.766 39.352c-.717 3.028-3.046 4.73-6.17 5.304-2.743.497-5.028.618-7.222-1.127-2.677-2.221-2.71-5.9-.303-8.22 1.904-1.79 4.58-2.155 8.6-2.851.672-.122 1.254-.276 1.747-.818.717-.795.493-.453.493-18.032 0-1.237-.616-1.58-1.904-1.359-.918.155-20.794 3.823-20.794 3.823-1.142.243-1.5.575-1.5 1.845 0 25.932.123 24.739-.28 26.462-.47 2.011-1.725 3.525-3.382 4.365-1.881 1.027-5.285 1.48-7.1 1.149-4.837-.895-6.539-6.409-3.258-9.569 1.904-1.79 4.58-2.154 8.6-2.85.672-.122 1.254-.276 1.747-.818 1.13-1.27.201-28.351.582-29.854.09-.574.336-1.06.795-1.425.47-.387 1.321-.608 1.5-.608C37.761.55 40.55.007 40.942.007c1.288-.088 2.027.663 2.027 1.945.022 38.063.123 36.02-.202 37.4z",
    fill: "#5C00C3"
  })));
}

export default SvgNotes;